/**
 * @class that caches DOM elements.
 * @version 1.0
 */
class CacheElement
{

  constructor()
  {
    this.elements = {
      single: {},
      multi: {}
    }
    return this;
  }

  /**
   * @method get_node cache single Nodes
   * @param {String} selector - CSS selector used to cache element
   * @return {Node}
   */
  get_node( selector )
  {
    const self = this;
    return self.elements.single[ selector ] = self.elements.single[ selector ] ? self.elements.single[ selector ] : document.querySelector( selector );
  }

  /**
   * @method get_nodelist cache multiple Nodes
   * @param {String} selector - CSS selector used to cache all elements
   * @return {NodeList}
   */
  get_nodelist( selector )
  {
    const self = this;
    return self.elements.multi[ selector ] = self.elements.multi[ selector ] ? self.elements.multi[ selector ] : document.querySelectorAll( selector );
  }
  /**
   * @method get_elements returns this.elements
   * @return {Object}
   */
  get_elements()
  {
    return this.elements;
  }

  has_class( selector, cl )
  {
    const self = this;
    return self.get_node( selector ).classList.contains( cl );
  }

  add_class( selector, cl )
  {
    const self = this;
    return self.get_node( selector ).classList.add( cl );
  }

  remove_class( selector, cl )
  {
    const self = this;
    return self.get_node( selector ).classList.remove( cl );
  }

  set_text( selector, text )
  {
    const self = this;
    self.get_node( selector ).textContent = text;
  }

  set_attribute( selector, attr, val )
  {
    const self = this;
    self.get_node( selector ).setAttribute( attr, val );
  }

  get_attribute( selector, attr )
  {
    const self = this;
    self.get_node( selector ).getAttribute( attr );
  }
}